export default __webpack_public_path__ + "static/media/mwike_sz.9727672f.png";